import { render, staticRenderFns } from "./GeneralLedger.vue?vue&type=template&id=a586b92e&scoped=true"
import script from "./GeneralLedger.vue?vue&type=script&lang=js"
export * from "./GeneralLedger.vue?vue&type=script&lang=js"
import style0 from "./GeneralLedger.vue?vue&type=style&index=0&id=a586b92e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a586b92e",
  null
  
)

export default component.exports